"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financingReducer = void 0;
const object_utils_1 = require("../utils/object-utils");
const financingAction_1 = require("../actions/financingAction");
const INIT_STATE = {};
const financingReducer = (financing = INIT_STATE, action) => {
    switch (action.type) {
        case financingAction_1.ADD_FINANCING_FOR_VEHICLE:
            const financingClone = (0, object_utils_1.deepCopy)(financing);
            const financingVehicleClone = (0, object_utils_1.deepCopy)(financingClone[action.payload.vehicleId]) || {};
            financingClone[action.payload.vehicleId] = Object.assign(Object.assign({}, financingVehicleClone), (0, object_utils_1.deepCopy)(action.payload.financing));
            return financingClone;
        default:
            return financing;
    }
};
exports.financingReducer = financingReducer;
//# sourceMappingURL=financing.reducer.js.map